import { useNavigate } from 'react-router';
import { authApi } from '@/api/client';
import { useAuthStore } from '@/stores/authStore';

interface HeaderProps {
  title: string;
  subtitle?: string;
}

export function Header({ title, subtitle }: HeaderProps) {
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch {
      // Ignore errors, logout anyway
    }
    logout();
    navigate('/login');
  };

  return (
    <header className="bg-cyber-dark/50 border-b border-cyber-light px-4 py-3">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-lg font-display text-white tracking-wide">{title}</h1>
          {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
        </div>
        <button onClick={handleLogout} className="cyber-button text-sm">
          Выход
        </button>
      </div>
    </header>
  );
}
